import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import { HomeHero } from "@/components/home/HomeHero";
import { PathSelector } from "@/components/home/PathSelector";
import { MarqueeStrip } from "@/components/home/MarqueeStrip";
import { CredibilityStrip } from "@/components/home/CredibilityStrip";
import { CoachPreview } from "@/components/home/CoachPreview";
import EBookSection from "@/components/EBookSection";
import ClothingSection from "@/components/ClothingSection";
import Footer from "@/components/Footer";
import BasketballPage from "@/pages/BasketballPage";
import FitnessPage from "@/pages/FitnessPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "@/pages/TermsAndConditionsPage";
import { ScrollProgress } from "@/components/ScrollProgress";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 150);
    }
  }, [location.state]);

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <HomeHero />
      <PathSelector />
      <MarqueeStrip />
      <CredibilityStrip />
      <CoachPreview />
      <EBookSection />
      <ClothingSection />
      <Footer />
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.1 });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ScrollProgress />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/basketball" element={<BasketballPage />} />
          <Route path="/fitness" element={<FitnessPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
